export class CostReviewFireEnUsExecutionSchedule {
  isExecutionScheduleCheckedLessThanThreshold!: boolean;
  isExecutionScheduleChecked!: boolean;
  phasedInstallationOccupancy!: number;
  projectSchedulePublished!: number;
  firePlanIdentified!: number;
  localOfficeTechnicalCompetencies!: number;
  localOfficeStaffedForWork!: number;
  specialCommissioningProceduresRequired!: number;
  designConsiderations!: number;
  unionProject!: number;
  specialTaggingRequirements!: number;
  responsibleForHazardousMaterials!: number;
  confinedWorkSpace!: number;
  responsibleForInaccessibleAccess!: number;
}
